export default "__VITE_ASSET__B1YhVK63__"